var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#A0A3BD",
    d: "M4.587 12.1v-1.38M8 12.1V9.34M11.413 12.1V7.953"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#A0A3BD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.413 3.9l-.306.36a12.588 12.588 0 01-6.52 4.026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46 3.9h1.954v1.946",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.667c3.333 0 4.667-1.334 4.667-4.667V6c0-3.333-1.334-4.667-4.667-4.667H6C2.667 1.333 1.333 2.667 1.333 6v4c0 3.333 1.334 4.667 4.667 4.667h4z",
    stroke: "#403D5A",
    strokeLinejoin: "round"
  }))));
}

export default SvgStatusUp;